import React from 'react';
import { Contact } from '../types';

interface ContactItemProps {
  contact: Contact;
  variant?: 'badge' | 'card';
  showRole?: boolean;
  className?: string;
}

const ContactItem: React.FC<ContactItemProps> = ({ 
  contact, 
  variant = 'badge', 
  showRole = false,
  className = ''
}) => {
  const baseClasses = "font-satoshi font-medium inline-flex items-center justify-center transition-all duration-200";
  const cursorClasses = contact.email ? "cursor-pointer hover:border-blue-200" : "cursor-default";
  
  const variantClasses = variant === 'badge' 
    ? "bg-blue-50 text-blue-600 px-3 py-1 text-lg rounded-full border border-transparent" 
    : "bg-blue-50 text-blue-600 px-3 py-1 text-lg rounded-full border border-transparent";

  const handleClick = () => {
    if (contact.email) {
      window.location.href = `mailto:${contact.email}`;
    }
  };

  const renderContent = () => {
    if (variant === 'card' && showRole) {
      return `${contact.name} · ${contact.role}`;
    }

    return `${contact.name}${showRole && contact.role ? ` · ${contact.role}` : ''}`;
  };

  return (
    <div
      className={`${baseClasses} ${cursorClasses} ${variantClasses} ${className}`}
      onClick={handleClick}
      title={contact.email ? "Contact me" : contact.name}
    >
      {renderContent()}
    </div>
  );
};

export default ContactItem; 